import React from 'react';
import { useFelaEnhanced } from '@ackee/fela';
import type { BlogPostsPageContext } from '../../types';
import { PageLink } from './PageLink';
import { PageNumberLink } from './PageNumberLink';
import { PagesRangeDelimiter } from './PagesRangeDelimiter';

import * as felaRules from './Pagination.rules';

export interface PaginationProps extends BlogPostsPageContext {
    basePath: string;
}

export const Pagination = ({ basePath, numPages, currentPage }: PaginationProps) => {
    const { rules } = useFelaEnhanced(felaRules);

    if (numPages < 2) {
        return null;
    }

    const prevPage = currentPage - 1;
    const nextPage = currentPage + 1;

    const pages = [prevPage - 1, prevPage, currentPage, nextPage, nextPage + 1].filter(
        page => page > 1 && page < numPages,
    );

    return (
        <>
            {prevPage > 0 && (
                <PageLink
                    basePath={basePath}
                    page={prevPage}
                    label="&lt;"
                    extend={{
                        button: rules.prevNextButton,
                    }}
                />
            )}

            <PageNumberLink basePath={basePath} page={1} currentPage={currentPage} />

            {pages[0] > 2 && <PagesRangeDelimiter />}

            {pages.map(page => (
                <PageNumberLink key={page} basePath={basePath} page={page} currentPage={currentPage} />
            ))}

            {pages[pages.length - 1] < numPages - 1 && <PagesRangeDelimiter />}

            <PageNumberLink basePath={basePath} page={numPages} currentPage={currentPage} />

            {nextPage < numPages && (
                <PageLink
                    basePath={basePath}
                    page={nextPage}
                    label="&gt;"
                    extend={{
                        button: rules.prevNextButton,
                    }}
                />
            )}
        </>
    );
};
